import React from 'react';

import { FlyoutTrigger } from './FlyoutTrigger';
import { Samples } from './product-samples/components/Samples';

import type { SamplesProps } from './product-samples/components/Samples';

export const SamplesWrapper: React.FC<SamplesProps> = (props) => {
  return <Samples {...props} trigger={FlyoutTrigger} />;
};
